import { jwtDecode } from 'jwt-decode';

interface AccessTokenPayload {
  roles?: string[];
}

export function parseAccessTokenRoles(accessToken: string): string[] {
  try {
    const payload = jwtDecode<AccessTokenPayload>(accessToken);
    return payload.roles ?? [];
  } catch {
    return [];
  }
}
